(function () {
	'use strict';

	// Alternative sticky header
	let menu = document.getElementsByTagName('header')[0];
	var oldScrollY = window.scrollY;
	if (menu.classList.contains('has-sticky')) {
		window.addEventListener('scroll', () => {
			let pos;
			if (menu.classList.contains('sticky')) {
				pos = 116; // height of div, if sticky
			} else {
				pos = 400; // height of div, if not sticky
			}
			window.scrollY > pos ? menu.classList.add("sticky") : menu.classList.remove("sticky");
			window.scrollY > oldScrollY ? menu.classList.add("scroll-down") : menu.classList.remove("scroll-down");
			oldScrollY = window.scrollY;
		})
	}

	// Add link to home page when clicking #logo (no jQuery)
	document.getElementById('logo').addEventListener('click', function () {
		window.location.href = '/';
	});

	function mobileMenu() {
		// Copy the 'my account' buttons to the mobile menu
		var myAccount = document.querySelector('.my-account');
		var mobileMenu = document.getElementById('modal-3-content');
		var deviceWidth = (window.innerWidth > 0) ? window.innerWidth : screen.width;

		if (deviceWidth < 768) {
			if (mobileMenu) {
				// Add flyout menu
				var flyoutMenu = document.createElement('div');
				flyoutMenu.className = 'facetwp-flyout-open';
				flyoutMenu.innerHTML = 'Filtre';
				mobileMenu.appendChild(flyoutMenu);
			}
			if (myAccount && mobileMenu) {
				mobileMenu.appendChild(myAccount.cloneNode(true));
			}

			// Copy the 'search' form to the mobile menu
			var searchForm = document.querySelector('.asp_w_container');
			if (searchForm && mobileMenu) {
				mobileMenu.appendChild(searchForm.cloneNode(true));

				// Remove the original search form
				searchForm.parentNode.removeChild(searchForm);
			}
		} else {
			// ToDo: reset on desktop and activate onchange event
		}

		// Add expand icon to submenus
		var submenus = document.querySelectorAll('.wp-block-navigation-submenu');
		if (submenus) {
			submenus.forEach(function (submenu) {
				submenu.innerHTML += '<span class="expand-submenu"></span>';
			});
		}
		// Add click event to expand icon
		var expandSubmenu = document.querySelectorAll('.expand-submenu');
		if (expandSubmenu) {
			expandSubmenu.forEach(function (expand) {
				expand.addEventListener('click', function () {
					// remove 'active' class from all other submenus
					var submenus = document.querySelectorAll('.wp-block-navigation-submenu');
					submenus.forEach(function (submenu) {
						submenu.classList.remove('active');
					});
					// add 'active' class to the previous sibling
					this.previousElementSibling.classList.toggle('active');
				});
			});
		}
		// .wp-block-navigation__submenu-container
	}
	mobileMenu();
	// window.addEventListener("resize", function(event) {
	// 	mobileMenu();
	// })

	// Hide menu, if clicking outside of it
	var mobileMenu = document.getElementById('modal-3');
	if (mobileMenu) {
		window.addEventListener('click', function (e) {
			let menuToggle = true
			const target = e.target;
			if (target.getAttribute("data-micromodal-trigger")) {
				menuToggle = false;
			}
			if (menuToggle) {
				mobileMenu.classList.remove('is-menu-open');
				mobileMenu.classList.remove('has-modal-open');
				mobileMenu.setAttribute('aria-hidden', 'true');
			}
		});
		mobileMenu.addEventListener('click', function (event) {
			event.stopPropagation();
		});
	}

	// Enforce target=blank for socials
	var socials = document.querySelectorAll('.wp-social-link');
	if (socials) {
		socials.forEach(function (social) {
			social.setAttribute('target', '_blank');
		});
	}

	// Register form
	var registerLink = document.getElementsByClassName('uwp-register-link')[0];
	if (registerLink) {
		registerLink.addEventListener('click', function () {
			setTimeout(() => {
				var registerForm = document.getElementsByClassName('uwp-registration-form')[0];
				// copy the email field to the username field
				var emailField = registerForm.querySelector('input[name="email"]');
				var usernameField = registerForm.querySelector('input[name="username"]');
				// setup change event for the email field
				emailField.addEventListener('change', function () {
					// remove all non-alphanumeric characters, except @ and dots and make lowercase
					var username = this.value.replace(/[^a-zA-Z0-9@.]/g, '');
					usernameField.value = username.toLowerCase();
				});
			}, 3000);
		});
	}

	var registerForm = document.getElementsByClassName('uwp-registration-form')[0];
	console.log(registerForm)
	if (registerForm) {
		console.log(registerForm)
		var emailField = registerForm.querySelector('input[name="email"]');
		var usernameField = registerForm.querySelector('input[name="username"]');
		emailField.addEventListener('change', function () {
			var username = this.value.replace(/[^a-zA-Z0-9@.]/g, '');
			usernameField.value = username.toLowerCase();
		});
	}

})();

